import { ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { PlanLimitError } from '../../features/plans/models/enforcement.model';
import { ExpertRole } from '../../models/expert-role.model';
import { SessionInfoDto } from '../../models/chat/chat-session.models';
import { ChatSource, CsvDocumentInfo } from '../../models/chat.model';
import { ChatInputMode, ChatItem } from '../../models/chat-ui.model';
import { ParsedSourceSummary } from '../../services/chat/presentation/chat-answer-sources.service';

export const CHAT_NON_EXPERT_ROLE = 'general';

export class ChatRuntimeState {
  readonly destroy$ = new Subject<void>();
  limitedDocValue: string | null = null;
  limitedDocId: string | null = null;
  limitedDocName: string | null = null;
  showDownloadedMessage = false;
  activeRequests = 0;
  showToolsPanel = false;
  feedbackRating = 0;
  hoverRating = 0;
  topK = 5;
  mobileChatOptionsOpen = false;
  selectedInputMode: ChatInputMode = 'obtener_informacion_documento';
  armedGenerateSummary = false;
  expertRoles: ExpertRole[] = [];
  selectedExpertRole: string | null = null;
  expertRolesLoading = false;
  expertRolesError = false;
  lastAppliedExpertRole: string | null = null;
  lastRequestedExpertRole: string | null = null;
  isRoleDropdownOpen = false;
  showSessionNameSuccess: string | null = null;
  editingSessionId: string | null = null;
  editingSessionName = '';
  pendingAutoTitleText: string | null = null;
  sessionNameError = false;
  chatForm!: FormGroup;
  messages: ChatItem[] = [];
  isLoading = false;
  error: string | null = null;
  planLimitError: PlanLimitError | null = null;
  isRequesting = false;
  showFeedback = false;
  feedbackSent = false;
  feedbackComment = '';
  feedbackTargetIndex: number | null = null;
  feedbackLike: boolean | null = null;
  copiedMessageIndex: number | null = null;
  selectedMessageId: string | null = null;
  showDetails = false;
  currentSources: ChatSource[] = [];
  selectedSource: ChatSource | null = null;
  selectedChunkId: string | null = null;
  showCsvModal = false;
  pendingQuery = '';
  csvDocuments: CsvDocumentInfo[] = [];
  showSessionModal = false;
  sessionList: SessionInfoDto[] = [];
  sessionModalTitle = 'Selecciona una sesión';
  selectedSessionId: string | null = null;
  userAvatarUrl: string | null = null;
  summaryCacheKey: ChatSource | null = null;
  summaryCacheValue: ParsedSourceSummary | null = null;
  contextModalVisible = false;
  contextModalX = 0;
  contextModalY = 0;
  contextModalSource: ChatSource | null = null;
  confirmContext = false;
  buttonText = 'Tools';
  chatTextarea?: ElementRef<HTMLTextAreaElement>;
  chatContainer?: ElementRef<HTMLElement>;
  detailsPanel?: ElementRef<HTMLElement>;
  cursorHintRef?: ElementRef<HTMLElement>;
}
